import * as actions from './actions'
import createListReducer from 'modules/higherOrder/createListReducer'

export default createListReducer(actions)